<script lang="ts">
  import type { Job } from "@puntocrypto/core";
  import { createJobStore } from "../jobs";
  import JobListItem from "./JobListItem.svelte";
  import { userStore, redirectToAuthorizationFlow } from "../auth";
  import Button from "./Button.svelte";

  const jobStore = createJobStore();

  const baseClass =
    "mt-5 flex-col shadow-lg border rounded-lg divide-y  divide-gray-500";
  let klass = "";

  export { klass as class };

  let jobList: [string, Job][] = [];
  $: if ($jobStore) {
    jobList = Object.entries($jobStore);
  }
</script>

<ul class={baseClass + ' ' + klass}>
  {#if $userStore === null}
    <li class="p-4 flex items-center">
      <p class="flex-1">Please log in first to see your active importers</p>
      <Button on:click={redirectToAuthorizationFlow}>Login with YNAB</Button>
    </li>
  {:else if jobList.length === 0}
    <li class="p-4 flex items-center">
      <p class="flex-1 text-yellow-500">You have not set up any importers</p>
    </li>
  {:else}
    {#each jobList as [jobId, job] (jobId)}
      <JobListItem {job} {jobId} />
    {/each}
  {/if}
</ul>
